<template>
  <EasyDataTable
    ref="dataTable"
    table-class-name="vue3-easy-data-table table-shadow"
    :server-items-length="serverItemsLength"
    :loading="loading"
    :headers="headers"
    :items="items"
    :prevent-context-menu-row="false"
    :fixed-header="false"
    no-hover
    alternating
    hide-footer
  >
    <template #loading>
      <b-spinner class="mt-5" variant="success" />
    </template>
    <template #item="{ column, item }: { column: string; item: TrackingEvent }">
      <RowDate v-if="column === 'eventTime'" :date="item.eventTime" />
      <span v-if="column === 'status'">
        <span v-if="item.type === 'internal' && isStaff">Internal scan</span>
        <span v-else>
          {{ trackingStatus2Name(item.status, '') }}
        </span>
      </span>
      <span v-if="column === 'description'">
        {{ item.description }}
        <div v-if="item.locationName" class="text-muted mt-1">
          <span
            :class="{
              fa: true,
              'orange-link': item.type === 'internal',
              'fa-map-pin': true,
            }"
          />
          {{ item.locationName }}
        </div>
      </span>
    </template>
  </EasyDataTable>
</template>

<script lang="ts">
import type { TrackingEvent } from '@/types/Models/Tracking'
import { BSpinner } from 'bootstrap-vue-next'
import { defineComponent, ref, onMounted, computed, type ComputedRef } from 'vue'
import { trackingStatus2Name } from '@/services/Helpers'
import { useAccountStore } from '@/store/account'
import { useShipmentStore } from '@/store/shipment'
import EasyDataTable, { type Header } from 'vue3-easy-data-table'
import RowDate from '@/views/Components/Elements/Table/RowDate.vue'

export default defineComponent({
  name: 'EventsCollection',
  components: { BSpinner, RowDate, EasyDataTable },
  props: {
    shipmentNumber: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const accountStore = useAccountStore()
    const shipmentStore = useShipmentStore()
    const dataTable = ref()

    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)
    const loading: ComputedRef<boolean> = computed(() => shipmentStore.trackingEventsLoading)
    const items: ComputedRef<TrackingEvent[]> = computed(() => shipmentStore.trackingEventsList(props.shipmentNumber))
    const serverItemsLength: ComputedRef<number> = computed(() =>
      shipmentStore.trackingEventsTotal(props.shipmentNumber),
    )

    const headers: Header[] = [
      { text: 'Time', value: 'eventTime' },
      { text: 'Status', value: 'status' },
      { text: 'Description', value: 'description' },
    ]
    const fetchMessages = () => {
      shipmentStore.fetchTrackingEvents(props.shipmentNumber)
    }

    onMounted(fetchMessages)

    return {
      items,
      isStaff,
      headers,
      loading,
      dataTable,
      serverItemsLength,
      trackingStatus2Name,
    }
  },
})
</script>
